import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Keeps scroll position per pathname
const scrollPositions = {};

export default function useScrollRestoration() {
  const location = useLocation();

  useEffect(() => {
    const pathname = location.pathname;
    // Restore scroll position if exists
    if (scrollPositions[pathname] !== undefined) {
      window.scrollTo(0, scrollPositions[pathname]);
    } else {
      window.scrollTo(0, 0);
    }
    // On unmount, save scroll position
    return () => {
      scrollPositions[pathname] = window.scrollY;
    };
    // eslint-disable-next-line
  }, [location.pathname]);
}
